import { sendMessage, processResponse } from '@/services/chatService';

const state = {
  messages: [],
  isLoading: false,
  inputValue: '',
  timestamp: Date.now(),
  apiUrl: 'https://cobalt-v1-92585043467.southamerica-east1.run.app/chat-consultation',
  error: null,
};

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_INPUT_VALUE(state, value) {
    state.inputValue = value;
  },
  ADD_USER_MESSAGE(state, messageText) {
    const userMessage = {
      user: messageText,
      bot: {
        documents: [],
      },
    };
    // Add to beginning of array (newest first)
    state.messages = [userMessage, ...state.messages];
  },
  ADD_BOT_RESPONSE(state, document) {
    // Add bot response to the most recent user message
    if (state.messages[0] && state.messages[0].bot) {
      state.messages[0].bot.documents.push(document);
    }
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  },
  CLEAR_MESSAGES(state) {
    state.messages = [];
  },
  SET_API_URL(state, url) {
    state.apiUrl = url;
  },
  RESET_TIMESTAMP(state) {
    state.timestamp = Date.now();
  },
};

const actions = {
  async sendMessage({ commit, state }, messageText) {
    if (state.isLoading || !messageText.trim()) {
      return;
    }

    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    commit('SET_INPUT_VALUE', '');

    // Add user message to history
    commit('ADD_USER_MESSAGE', messageText);

    try {
      // Send message to API
      const response = await sendMessage(messageText, state.timestamp, {
        apiUrl: state.apiUrl,
      });

      // Process response
      const document = processResponse(response);

      // Add bot response to the user message
      commit('ADD_BOT_RESPONSE', document);
    } catch (error) {
      console.error('Error sending message:', error);
      commit('SET_ERROR', error);
      // Optionally, you could add an error message to the chat
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  updateInputValue({ commit }, value) {
    commit('SET_INPUT_VALUE', value);
  },
  clearMessages({ commit }) {
    commit('CLEAR_MESSAGES');
  },
  setApiUrl({ commit }, url) {
    commit('SET_API_URL', url);
  },
  resetSession({ commit }) {
    commit('RESET_TIMESTAMP');
    commit('CLEAR_MESSAGES');
    commit('CLEAR_ERROR');
    commit('SET_INPUT_VALUE', '');
  },
};

const getters = {
  messages: (state) => state.messages,
  isLoading: (state) => state.isLoading,
  inputValue: (state) => state.inputValue,
  error: (state) => state.error,
  apiUrl: (state) => state.apiUrl,
  hasMessages: (state) => state.messages.length > 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

